document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('.menu-item');
  let timeout;

  menuItems.forEach(item => {
    item.addEventListener('mouseenter', function() {
      clearTimeout(timeout);
      // Hide all other megamenus first
      document.querySelectorAll('.megamenu').forEach(menu => {
        menu.classList.remove('mega-active');
      });
      // Show this item's megamenu
      const megamenu = this.querySelector('.megamenu');
      if (megamenu) {
        megamenu.classList.add('mega-active');
      }
    });

    item.addEventListener('mouseleave', function() {
      timeout = setTimeout(() => {
        const megamenu = this.querySelector('.megamenu');
        if (megamenu) {
          megamenu.classList.remove('mega-active');
        }
      }, 200); // Small delay to allow mouse movement between gap
    });
  });
});